import Vue from 'vue'
import App from './App.vue'
import router from './router'

// element-ui 按需引入（仅引入实际使用的组件）
import { Dialog, Form, FormItem, Input, Switch, Tag, Message, MessageBox, Loading } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Dialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Switch)
Vue.use(Tag)

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$loading = Loading.service

import './styles/global.css'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
